// import React from "react";
// import AptitestLogo from "./images/aptitestlogo.jpg";
// import Lms from "./images/1.png";
// import Robot from "./images/robot-human.jpg";
// import Rain from "./images/Moderate Rain.svg";
// import Bms from "./images/BMS.jpg";
// import Leetcode from "./images/leetcode.jpg";
// import Hackerrank from "./images/hackerrank.jpg";
// function MainContent() {
//   return (
//     <div className="container">
//       <div className="content">
//         <div className="profile-text">
//           <h1>Goli Vishnuvardhan Reddy</h1>
//           <h3>
//             Versatile Electronics and Communication Engineer with a Passion for
//             Python Development
//           </h3>
//           <p>
//             I am an undergraduate student currently pursuing a major in
//             Electronics and Communication Engineering with a minor in Artificial
//             Intelligence and Machine Learning. I have a deep passion for
//             development, particularly in the field of Python programming. I am
//             an active, enthusiastic, and knowledge-thirsty individual, always
//             seeking to expand my skills and contribute to the world of
//             technology.
//           </p>
//         </div>
//       </div>

//       <div className="section">
//         <h2>Education</h2>
//         <ul>
//           <li>
//             <span className="h3">2018:</span> 10th, Tetrahedron Model School -
//             9.5 CGPA
//           </li>
//           <li>
//             <span className="h3">2020:</span> Intermediate, Alphores Junior
//             College - 98.7%
//           </li>
//           <li>
//             <span className="h3">2020-2024:</span>B.Tech , Electronics and
//             Communication Engineering, VNR Vignana Jyothi Institute of
//             Engineering and Technology - 9.35 CGPA (up to 5th semester)
//           </li>
//         </ul>
//       </div>

//       <div className="section">
//         <h2>Projects</h2>
//         <ul>
//           <li>
//             <img
//               src={AptitestLogo}
//               alt="aptitest"
//               className="project"
//               style={{ width: "50%" }}
//             />
//             <span className="h3" style={{ display: "block" }}>
//               1️⃣ Aptitest
//             </span>
//             <p>
//               AptiTest provides access to various companies "recruitment tests"
//               previous year questions, helping students prepare for their dream
//               job
//             </p>
//             <a href="https://aptitest-4fa07.web.app">Check out AptiTest</a>
//             <hr />
//           </li>
//           <img src={Lms} alt="LMS" style={{ width: "50%" }} />
//           <li>
//             <span className="h3 project" style={{ display: "block" }}>
//               2️⃣ Library Management System
//             </span>
//           </li>
//           <p>
//             Designed and implemented a web-based application to manage Library
//             Operations efficiently.
//           </p>
//           <a href="https://binaryblaze.pythonanywhere.com/">
//             Check out Library Management System
//           </a>
//           <hr />
//           <img src={Robot} alt="electrika" style={{ width: "50%" }} />
//           <li>
//             <span className="h3" style={{ display: "block" }}>
//               3️⃣ Electrika - An AI ChatBot
//             </span>
//             <p>
//               Meet Electrika, the AI-powered chatbot that specializes in
//               providing accurate and comprehensive answers to all your
//               electronics-related queries.
//             </p>
//             <a href="https://electrika.pythonanywhere.com/">
//               Check out Electrika
//             </a>
//           </li>
//           <hr />

//           <img src={Rain} alt="weather app" style={{ width: "50%" }} />
//           <li>
//             <span className="h3">4️⃣ Weather App</span>
//           </li>
//           <p>a simple user-friendly weather app created using rapid API.</p>
//           <a href="https://clima-cast.web.app/">Check Out My weather app</a>
//           <hr />
//           <br />
//           <br />
//           <img
//             src={Bms}
//             alt="Battery Management system"
//             style={{ width: "50%" }}
//           />
//           <li>
//             <span className="h3">
//               5️⃣ Battery Management System for Electric Vehicle
//             </span>
//           </li>
//           <p>
//             Battery Health status is continuously monitored and when there is an
//             abnormal situation arises battery is isolated.
//           </p>
//           <a href="https://clima-cast.web.app/">Check Out My weather app</a>
//         </ul>
//       </div>

//       <div className="section">
//         <h2>⭐Internship</h2>
//         <p>
//           <span className="h4">
//             Python Automation Developer, Cantellat Software Pvt Ltd, Jan 2023 -
//             Mar 2023
//           </span>
//         </p>
//         <ul>
//           <li>
//             <span className="h3">Description:</span> Developed and executed
//             automated test scripts using Selenium WebDriver for web
//             applications, resulting in a 20% reduction in testing time. Gained
//             proficiency in creating custom test frameworks with Selenium and
//             Python programming language, used for automating repetitive test
//             cases. Participated in team meetings and contributed to the
//             development of new testing strategies.
//           </li>
//           <li>
//             <span className="h3">skills:</span> Git · GitHub · Selenium ·
//             Selenium WebDriver · Selenium Testing · Unit Testing · Python
//             (Programming Language)
//           </li>
//         </ul>
//       </div>

//       <div className="section">
//         <h2>Technical Skills</h2>
//         <ul>
//           <li>➡️C</li>
//           <li>➡️Python</li>
//           <li>➡️Java</li>
//           <li>➡️Object-oriented Programming</li>
//           <li>➡️Flask Microweb Framework</li>
//           <li>➡️HTML</li>
//           <li>➡️CSS</li>
//           <li>➡️JavaScript</li>
//           <li>➡️Data Structures and Algorithms</li>
//           <li>➡️Git</li>
//           <li>➡️GitHub</li>
//         </ul>
//       </div>
//       <div className="section">
//         <h2>Soft Skills</h2>
//         <ul>
//           <li>Communication Skills</li>
//           <li>Team Management</li>
//           <li>Critical Thinking</li>
//           <li>Problem Solving</li>
//         </ul>
//       </div>
//       <div className="section">
//         <h2>Achievements</h2>
//         <ul type="I">
//           <li>🏆Secured first prize in Project Contest in CONVERGENCE-2K23.</li>
//           <li>
//             ✅Solved more than 200+ DSA problems in various coding platforms.
//           </li>
//           <li>➡️4⭐ in Hackerrank Problem Solving.</li>
//           <li>
//             ✅Secured LinkedIn skill assessment badge in Python (Programming
//             Language).
//           </li>
//           <li>
//             ✅Secured LinkedIn skill assessment badge in Object-oriented
//             programming.
//           </li>
//           <li>
//             🥇Offered Scholarship by central Government for being in top 1% in
//             Intermediate Board Examinations.
//           </li>
//         </ul>
//       </div>

//       <div className="section">
//         <h2>Certifications</h2>
//         <ul>
//           <li>1️⃣ Smart Coder from Smart Interviews June 2023.</li>
//           <li>
//             2️⃣ Introduction to Cybersecurity from Cisco Networking Academy.
//           </li>
//           <li>
//             3️⃣ Goldman Sachs Virtual Experience Program on Forage – May 2022
//           </li>
//           <li>4️⃣ Python Object-Oriented Programming from LinkedIn Learning.</li>
//           <li>5️⃣ Python Essentials 1 from Cisco Networking Academy.</li>
//         </ul>
//       </div>

//       <div className="section-resume">
//         <h2>Resume</h2>
//         <a
//           href="resume vishnuvardhan reddy.pdf"
//           download
//           className="download-button"
//         >
//           Download Resume
//         </a>
//       </div>
//       <div className="section">
//         <h2>My Coding Profiles</h2>
//         <ul>
//           <li>
//             <h3 style={{ textAlign: "center" }}>Leetcode</h3>
//             <figure className="profile-figure">
//               <img src={Leetcode} alt="LeetCode Profile" />
//             </figure>
//           </li>
//           <li>
//             <h3 style={{ textAlign: "center" }}>Hackerrank</h3>
//             <figure className="profile-figure">
//               <img src={Hackerrank} alt="LeetCode Profile" />
//             </figure>
//           </li>
//         </ul>
//       </div>

//       <div className="section" id="#contact">
//         <h2>Contact</h2>
//         <ul>
//           <li>
//             <span className="h3">Email:</span> vishnuvardhan.goli315@gmail.com
//           </li>
//           <li>Phone: 9618835376</li>
//           <li>
//             LinkedIn:
//             <a href="https://www.linkedin.com/in/vishnuvardhan-reddy-goli">
//               Vishnuvardhan Reddy Goli
//             </a>
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// }

// export default MainContent;

import React from "react";
import AptitestLogo from "./images/aptitestlogo.jpg";
import Lms from "./images/1.png";
import Rain from "./images/Moderate Rain.svg";
import Bms from "./images/BMS.jpg";
import Leetcode from "./images/leetcode.jpg";
import Hackerrank from "./images/hackerrank.jpg";
import ChatApp from "./images/chat-app.jpg";
import Resume from "./images/resume.jpeg";
import Cantellat from "./images/cantellat.png";
import { FaBriefcase, FaGraduationCap } from "react-icons/fa";
import Amazon from "./images/amazon.jpg";
import codechef from "./images/codechef.png";
import geeksforgeeks from "./images/Geeksforgeeks.jpeg";

function MainContent() {
  return (
    <div className="container">
      <div className="content">
        <div className="profile-text" id="about">
          <h1>Goli Vishnuvardhan Reddy</h1>
          <h3>
            Versatile Electronics and Communication Engineer with a Passion for
            Python Development
          </h3>
          <p>
            I am an undergraduate student currently pursuing a major in
            Electronics and Communication Engineering with a minor in Artificial
            Intelligence and Machine Learning. I have a deep passion for
            development, particularly in the field of Python programming. I am
            an active, enthusiastic, and knowledge-thirsty individual, always
            seeking to expand my skills and contribute to the world of
            technology.
          </p>
        </div>
      </div>

      <div className="section" id="education">
        <h2>Education</h2>
        <ul>
          <li>
            <span className="h3">2018:</span> 10th, Tetrahedron Model School -
            9.5 CGPA
          </li>
          <li>
            <span className="h3">2020:</span> Intermediate, Alphores Junior
            College - 98.7%
          </li>
          <li>
            <span className="h3">2020-2024:</span> B.Tech , Electronics and
            Communication Engineering, VNR Vignana Jyothi Institute of
            Engineering and Technology - 9.30 CGPA (up to 6th semester)
          </li>
        </ul>
      </div>

      <div className="section" id="projects">
        <h2>Projects</h2>
        <ul>
          <li>
            <img
              src={AptitestLogo}
              alt="aptitest"
              className="project"
              style={{ width: "50%" }}
            />
            <span className="h3" style={{ display: "block" }}>
              1️⃣ Aptitest
            </span>
            <p>
              AptiTest provides access to various companies "recruitment tests"
              previous year questions, helping students prepare for their dream
              job
            </p>
            <a href="https://aptitest-4fa07.web.app">Check out AptiTest</a>
            <hr />
          </li>
          <img src={Lms} alt="LMS" style={{ width: "50%" }} />
          <li>
            <span className="h3 project" style={{ display: "block" }}>
              2️⃣ Library Management System
            </span>
          </li>
          <p>
            Designed and implemented a web-based application to manage Library
            Operations efficiently.
          </p>
          <a href="https://binaryblaze.pythonanywhere.com/">
            Check out Library Management System
          </a>
          <hr />
          <img src={ChatApp} alt="chat-app" style={{ width: "50%" }} />
          <li>
            <span className="h3" style={{ display: "block" }}>
              3️⃣ Simple Messaging App using React
            </span>
            <p>A simple Chat app where users can send messages in group.</p>
            <a href="https://chatappgvr.web.app/">Check out my app</a>
          </li>
          <hr />

          <img src={Rain} alt="weather app" style={{ width: "50%" }} />
          <li>
            <span className="h3">4️⃣ Weather App</span>
          </li>
          <p>a simple user-friendly weather app created using rapid API.</p>
          <a href="https://clima-cast.web.app/">Check Out My weather app</a>
          <hr />
          <br />
          <br />
          <img
            src={Bms}
            alt="Battery Management system"
            style={{ width: "50%" }}
          />
          <li>
            <span className="h3">
              5️⃣ Battery Management System for Electric Vehicle
            </span>
          </li>
          <p>
            Battery Health status is continuously monitored and when there is an
            abnormal situation arises battery is isolated.
          </p>

          <img src={Resume} alt="resume" style={{ width: "50%" }} />
          <li>
            <span className="h3" style={{ display: "block" }}>
              6️⃣ Resume Screening App
            </span>
            <p>
              Natural Language based Resume Screeing app which predicts the job
              category based on the given resume.
            </p>
            <a href="https://resume-screening-minor.streamlit.app/">
              Check out my Resume Screening app
            </a>
          </li>
          <hr />
        </ul>
      </div>

      <div className="section" id="experience">
        <h2>
          <FaBriefcase style={{ marginRight: "0.5em" }} />
          Internship
        </h2>
        <img
          src={Cantellat}
          alt="aptitest"
          className="project"
          style={{ width: "50%" }}
        />
        <p>
          <span className="h4">
            Python Automation Developer, Cantellat Software Pvt Ltd, Jan 2023 -
            Mar 2023
          </span>
        </p>
        <ul>
          <li>
            <span className="h3">Description:</span> Developed and executed
            automated test scripts using Selenium WebDriver for web
            applications, resulting in a 20% reduction in testing time. Gained
            proficiency in creating custom test frameworks with Selenium and
            Python programming language, used for automating repetitive test
            cases. Participated in team meetings and contributed to the
            development of new testing strategies.
          </li>
          <li>
            <span className="h3">Project:</span> ServeCrust
          </li>
          <li>
            <span className="h3">skills:</span> Git · GitHub · Selenium ·
            Selenium WebDriver · Selenium Testing · Unit Testing · Python
            (Programming Language)
          </li>
        </ul>
      </div>
      <div className="section" id="trainings">
        <h2>
          <FaGraduationCap style={{ marginRight: "0.5em" }} />
          Apprenticeship
        </h2>
        <img
          src={Amazon}
          alt="amazon"
          className="project"
          style={{ width: "50%" }}
        />
        <p>
          <span className="h4">Amazon Summer School Participant - 2K23</span>
        </p>
        <ul>
          <li>
            <span className="h3">Description:</span> Attended Amazon ML Summer
            School 2023 - an integrated learning program for students on key
            Machine Learning (ML) topics including Supervised Learning, Deep
            Neural Networks, Dimensionality Reduction, Unsupervised Learning,
            Probabilistic Graphical Models, Sequential Learning, Causal
            Inference and Reinforcement Learning.
          </li>
        </ul>
      </div>

      <div className="section" id="services">
        <h2>Technical Skills</h2>
        <ul>
          <li>➡️C</li>
          <li>➡️Python</li>
          <li>➡️Java</li>
          <li>➡️Object-oriented Programming</li>
          <li>➡️Flask Microweb Framework</li>
          <li>➡️HTML</li>
          <li>➡️CSS</li>
          <li>➡️JavaScript</li>
          <li>➡️Data Structures and Algorithms</li>
          <li>➡️Git</li>
          <li>➡️GitHub</li>
        </ul>
      </div>

      <div className="section">
        <h2>Soft Skills</h2>
        <ul>
          <li>Communication Skills</li>
          <li>Team Management</li>
          <li>Critical Thinking</li>
          <li>Problem Solving</li>
        </ul>
      </div>

      <div className="section" id="achievements">
        <h2>Achievements</h2>
        <ul type="I">
          <li>🏆Secured first prize in Project Contest in CONVERGENCE-2K23.</li>
          <li>
            ✅Solved more than 200+ DSA problems in various coding platforms.
          </li>
          <li>➡️4⭐ in Hackerrank Problem Solving.</li>
          <li>
            ✅Secured LinkedIn skill assessment badge in Python (Programming
            Language).
          </li>
          <li>
            ✅Secured LinkedIn skill assessment badge in Object-oriented
            programming.
          </li>
          <li>
            🥇Offered Scholarship by central Government for being in top 1% in
            Intermediate Board Examinations.
          </li>
        </ul>
      </div>

      <div className="section">
        <h2>Certifications</h2>
        <ul>
          <li>1️⃣ Smart Coder from Smart Interviews June 2023.</li>
          <li>
            2️⃣ Introduction to Cybersecurity from Cisco Networking Academy.
          </li>
          <li>
            3️⃣ Goldman Sachs Virtual Experience Program on Forage – May 2022
          </li>
          <li>4️⃣ Python Object-Oriented Programming from LinkedIn Learning.</li>
          <li>5️⃣ Python Essentials 1 from Cisco Networking Academy.</li>
        </ul>
      </div>

      <div className="section-resume">
        <h2>Resume</h2>
        <a
          href="resume vishnuvardhan reddy.pdf"
          download
          className="download-button"
        >
          Download Resume
        </a>
      </div>

      <div className="section">
        <h2>My Coding Profiles</h2>
        <ul>
          <li>
            <h3 style={{ textAlign: "center" }}>Leetcode</h3>

            <img
              src={Leetcode}
              alt="LeetCode Profile"
              style={{ width: "50%", display: "block" }}
            />

            <a
              href="https://leetcode.com/vishnuvardhan_g6"
              className="coding-platform-link"
            >
              My Leetcode profile
            </a>
          </li>
          <li>
            <h3 style={{ textAlign: "center" }}>GeeksforGeeks</h3>

            <img
              src={geeksforgeeks}
              alt="GeeksforGeeks Profile"
              style={{ width: "50%", display: "block" }}
            />
            <a
              href="https://auth.geeksforgeeks.org/user/vishnuvardhangoli315/"
              className="coding-platform-link"
            >
              My GFG profile
            </a>
          </li>
          <li>
            <h3 style={{ textAlign: "center", display: "block" }}>CodeChef</h3>

            <img
              src={codechef}
              alt="codechef Profile"
              style={{ width: "50%", display: "block" }}
            />
            <a
              href="https://www.codechef.com/users/vishnu_315"
              className="coding-platform-link"
            >
              My CodeChef profile
            </a>
          </li>
          <li>
            <h3 style={{ textAlign: "center" }}>Hackerrank</h3>

            <img
              src={Hackerrank}
              alt="Hackerrank Profile"
              style={{ width: "50%", display: "block" }}
            />
            <a
              href="https://www.hackerrank.com/profile/vishnuvardhan_g6"
              className="coding-platform-link"
            >
              My Hackerrank profile
            </a>
          </li>
        </ul>
      </div>

      <div className="section" id="contact">
        <h2>Contact</h2>
        <ul>
          <li>
            <span className="h3">Email:</span> vishnuvardhan.goli315@gmail.com
          </li>
          <li>Phone: 9618835376</li>
          <li>
            LinkedIn:
            <a href="https://www.linkedin.com/in/vishnuvardhan-reddy-goli">
              Vishnuvardhan Reddy Goli
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default MainContent;
